'use strict';

angular.module('app.segmentationReportIndustry', [])
    .directive('segmentationReportIndustryDirective', function () {
        return {
            controller: 'segmentationReportIndustryCtrl',
            templateUrl: 'app/measure/segmentationReport/segmentationReportIndustry/segmentationReportIndustry.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })